module.exports = __webpack_public_path__ + "img/1565761024.d6e12d03.jpg";